export const isBetaFeatureEnabled = (featureName) => {
    var _a;
    const betaFeatures = ((_a = process.env.PEEK_APP_BETA_FEATURES) === null || _a === void 0 ? void 0 : _a.split(",")) || [];
    return betaFeatures.includes(featureName);
};
